import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Intro() {
  const { t } = useTranslation('toiture');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);

  return (
    <section id="intro" className="bg-white py-20 md:py-28 lg:py-32">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          ref={ref}
          className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Text */}
          <div>
            <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl leading-tight mb-6">
              {t('intro_h2')}
            </h2>
            <p className="text-gray-500 text-base md:text-lg leading-relaxed">
              {t('intro_text')}
            </p>
          </div>

          {/* Image */}
          <div className="rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20roofer%20installing%20asphalt%20shingles%20on%20a%20Quebec%20residential%20house%20roof%2C%20warm%20golden%20hour%20sunlight%2C%20dramatic%20angle%20showing%20the%20roof%20pitch%20and%20Saint-Lawrence%20river%20in%20the%20background%2C%20construction%20site%20with%20safety%20equipment%2C%20warm%20copper%20and%20slate%20tones%2C%20professional%20documentary%20photography%20style%2C%20no%20text%20visible&width=800&height=600&seq=toiture-intro1&orientation=landscape"
              alt="Couvreur professionnel certifié RBQ en action sur un chantier de toiture à Lévis"
              className="w-full h-64 md:h-80 object-cover"
              loading="lazy"
              width="800"
              height="600"
            />
          </div>
        </div>
      </div>
    </section>
  );
}